<!--header-->
<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>
    <ion-title>
      Scientific Highlights
    </ion-title>
    <img alt="PSI logo" slot="end" class="titleicon" [src]="assets + '/psi_logo.svg'" width="80px" routerLink="/home" />
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <ion-row>
    <!--Link to NUM Publication Highlights & Featured-->
    <ion-col>
      <ion-card>
        <ion-img class="img-title" alt="Header image of CNM" [src]="assets + '/info/num.jpg'"></ion-img>
        <ion-card-header>
          <ion-fab vertical="top" horizontal="end" edge>
            <a title="Link to the scientific highlights of CNM" href="https://www.psi.ch/num/publication-highlights"
              target="_blank" rel="noopener noreferrer">
              <ion-fab-button color="dark">
                <ion-icon name="open-outline"></ion-icon>
              </ion-fab-button>
            </a>
          </ion-fab>
          <ion-card-title>CNM</ion-card-title>
        </ion-card-header>
        <ion-card-content>
          CNM is the organisational home base for the research at PSI, which is based on the use of the PSI High
          Intensity Proton Accelerator HIPA and which spans the entire range from particle physics via solid, liquid or
          soft condensed matter science, chemistry, materials science and engineering to cultural heritage.
        </ion-card-content>
      </ion-card>
    </ion-col>
    <!--Link to GFA Scientific Highlights-->
    <ion-col>
      <ion-card>
        <ion-img class="img-title" alt="Header of CAS" [src]="assets + '/info/gfa.jpg'"></ion-img>
        <ion-card-header>
          <ion-fab vertical="top" horizontal="end" edge>
            <a title="Link to the scientific highlights of CAS" href="https://www.psi.ch/gfa/scientific-highlights"
              target="_blank" rel="noopener noreferrer">
              <ion-fab-button color="dark">
                <ion-icon name="open-outline"></ion-icon>
              </ion-fab-button>
            </a>
          </ion-fab>
          <ion-card-title>CAS</ion-card-title>
        </ion-card-header>
        <ion-card-content>
          The Center for Accelerator Science and Engineering (CAS) is responsible for the construction, operation and development
          of the particle accelerators at PSI.
        </ion-card-content>
      </ion-card>
    </ion-col>
  </ion-row>

  <ion-row>
    <!--Link to SLS Scientific Highlights and News-->
    <ion-col>
      <ion-card>
        <ion-img class="img-title" alt="Header image of the SLS" [src]="assets + '/info/sls.jpg'"></ion-img>
        <ion-card-header>
          <ion-fab vertical="top" horizontal="end" edge>
            <a title="Link to the scientific highlights and news of the SLS"
              href="https://www.psi.ch/sls/scientific-highlights-and-news" target="_blank" rel="noopener noreferrer">
              <ion-fab-button color="dark">
                <ion-icon name="open-outline"></ion-icon>
              </ion-fab-button>
            </a>
          </ion-fab>
          <ion-card-title>Swiss Light Source</ion-card-title>
        </ion-card-header>
        <ion-card-content>
          The Swiss Light Source (SLS) at the Paul Scherrer Institut is a third-generation synchrotron light source. In
          the design of SLS a high priority was given to the items quality (high brightness), flexibility (wide
          wavelength spectrum) and stability (very stable temperature conditions) for the primary electron beam and the
          secondary photon beams.
        </ion-card-content>
      </ion-card>
    </ion-col>
    <!--Link to SwissFEL Scientific Highlights-->
    <ion-col>
      <ion-card>
        <ion-img class="img-title" alt="Header image of the SwissFEL" [src]="assets + '/info/swissfel.jpg'"></ion-img>
        <ion-card-header>
          <ion-fab vertical="top" horizontal="end" edge>
            <a title="Link to the scientific highlights of the SwissFEL"
              href="https://www.psi.ch/swissfel/scientific-highlights" target="_blank" rel="noopener noreferrer">
              <ion-fab-button color="dark">
                <ion-icon name="open-outline"></ion-icon>
              </ion-fab-button>
            </a>
          </ion-fab>
          <ion-card-title>SwissFEL</ion-card-title>
        </ion-card-header>
        <ion-card-content>
          SwissFEL is Switzerland's X-ray free-electron laser (FEL) facility at the Paul Scherrer Institute in Villigen
          and part of the Photon Science Division. Experiments at the Swiss Free-Electron Laser will lead to an entirely
          new level of understanding of matter in biology, chemistry, engineering and materials science.
        </ion-card-content>
      </ion-card>
    </ion-col>
  </ion-row>
</ion-content>
